<template>
  <div>
    <div class='flex flex-row items-stretch px-2 py-2 w-full sticky top-0 z-30 h-16'>
      <input 
        class='form-input flex-grow rounded-r-0 border-r-0' 
        type='search' 
        placeholder='search' 
        v-model='searchString' />
      <button 
        class='block p-2 border flex-shrink-0 rounded-r'
        @click='toggleFilterOptions'>
        <adjustments-icon class='h-5' style='transform: rotate(90deg);' />
      </button>
      <div v-if='showFilterOptions'
        class='absolute w-full border-t left-0 bg-white z-50 flex flex-row items-stretch px-2 py-3 shadow-md gap-x-1' 
        style='top:100%;'>
        <label class='flex flex-row justify-start items-center gap-x-1 whitespace-no-wrap'>
          <input type='checkbox'
            class='form-checkbox'
            name='includeNoPosition'
            v-model='includeNoPosition'>
          <span class='text-xs uppercase'>Include No Position</span>
        </label>
        <label class='flex flex-row justify-start items-center gap-x-1 whitespace-no-wrap'>
          <input type='checkbox'
            class='form-checkbox'
            name='includeSpac'
            v-model='includeSpac'>
          <span class='text-xs uppercase'>스팩 포합</span>
        </label>
        <button
          class='hidden flex flex-row justify-start items-center gap-x-1 whitespace-no-wrap py-2 pl-2 pr-2 border border-gray-200 text-sm rounded-md text-gray-700 opacity-75 hover:opacity-100 hover:border-blue-300 hover:text-gray-900 hover:shadow-md'
          name='new-entity-form-btn'
          @click='copyToClipboard'>
          <clipboard-copy-icon class='h-4' />
          <span class='text-xs'>Copy to Clipboard</span>
        </button>
      </div>
    </div>
    <div class='ipo-portfolio-table-container overflow-auto border-t'>
      <table class='text-base table-fixed'>
        <thead class='sticky top-0 bg-white text-xs'>
          <tr>
            <th
              class='px-2 py-1 border-l border-r border-b text-left uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10'
              rowspan='2'>
              <div class='flex flex-row justify-between items-center'>
                <button
                  class='flex flex-row justify-between items-center p-0.5 gap-x-1'
                  @click='toggleShowAll'>
                  <component :is='toggleIcon' class='h-4' />
                  <span class='font-semibold'>종목명</span>
                  ({{ filterdIposLength }})
                </button>
              </div>
            </th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-left' rowspan='2'>기관경쟁률</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right' rowspan='2'>의무보유확약</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right' rowspan='2'>청약경쟁률</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right' rowspan='2'>상장일</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right' rowspan='2'>확정공모가</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right' rowspan='2'>전일주가</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right' rowspan='2'>괴리율</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-center' colspan='3'>배정내역</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-center' colspan='6'>보유/회수내역</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-left' rowspan='2'>락업해제일</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-left' rowspan='2'>비고</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-left' rowspan='2'>증권신고서</th>
          </tr>
          <tr>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>배정수량</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>배정금액</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>배정비중</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>현재보유수량</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>보유평가액</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>매도평단</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>회수손익</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>회수율</th>
            <th class='px-2 py-1 border-l border-r border-b uppercase tracking-wide text-sm whitespace-no-wrap bg-gray-100 sticky top-0 z-10 text-right'>수익률</th>
          </tr>
        </thead>
        <ipo-portfolio-group
          v-for='ipo in filteredIpos'
          :key='`ipo-portfolio-${ipo.name}`'
          :style='selectedRow(ipo.id)'
          @select-row='selectRow'
          :show-all='showAll'
          :ipo='ipo' />
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { ClipboardCopyIcon, ChevronDownIcon, ChevronRightIcon, AdjustmentsIcon } from '@vue-hero-icons/outline'
import IpoPortfolioGroup from '@/components/mobile/IpoPortfolioGroup.vue'

export default {
  name: 'IpoPortfolio',
  components: {
    IpoPortfolioGroup,
    ClipboardCopyIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    AdjustmentsIcon,
  },
  data () {
    return {
      selectedIpoId: 0,
      showAll: false,
      includeNoPosition: false,
      includeSpac: false,
      searchString: '',
      showFilterOptions: false,
    }
  },
  computed: {
    ...mapFields('ipos', [
      'ipoPortfolio',
    ]),
    filteredIpos () {
      return this.ipoPortfolio.filter(ipo => this.ipoIncludedInFilters(ipo))
    },
    filterdIposLength () {
      return this.filteredIpos.length
    },
    toggleIcon () {
      return this.showAll ? 'chevron-down-icon' : 'chevron-right-icon'
    },
  },
  methods: {
    ...mapActions('ipos', [
      'getIpoPortfolio',
    ]),
    ipoIncludedInFilters (ipo) {
      if (!this.includeSpac && this.ipoNameIsSpac(ipo)) {
        return false
      } else if (!this.ipoHasPosition(ipo) && !this.includeNoPosition) {
        return false
      } else if (this.searchString.length > 0 && !ipo.name.includes(this.searchString)) {
        return false
      }
      return true
    },
    ipoNameIsSpac (ipo) {
      return ipo.name.includes('스팩') || ipo.name.includes('기업인수')
    }, 
    ipoHasPosition (ipo) {
      return ipo.ipo_position_id > 0
    },

    refreshData () {
      this.getIpoPortfolio()
    },
    selectedRow (ipoId) {
      return (this.selectedIpoId == ipoId) ? 'background-color: lightyellow' : ''
    },
    selectRow (ipoId) {
      this.selectedIpoId = ipoId
    },
    numberStyle (number) {
      return !number ? '' : Number(number).toLocaleString()
    },
    toggleShowAll () {
      this.showAll = !this.showAll
    },
    toggleFilterOptions () {
      this.showFilterOptions = !this.showFilterOptions
    },
    ventureRatio () {
      // requested value from AI team
      return 0.3
    },
    highYieldRatio () {
      // requested value from AI team
      return 0.05
    },
    copyToClipboard () {
      let headers = ['종목명', '기관경쟁률', '의무보유확약', '청약경쟁률', '상장일', '확정공모가', '전일주가', '괴리율', '배정수량', '배정금액', '배정비중', '현재보유수량', '보유평가액', '매도평단', '회수손익', '회수율', '수익률', '락업해제일', '비고']
      let result = `${headers.join('\t')}\n`
      this.filteredIpos.forEach(ipo => {
        var allocatedPrice = ipo.details['확정공모가'] ? ipo.details['확정공모가'] : 0
        var baseAllocatedQuantity = ipo.details['기관배정주식수'] ? parseFloat(ipo.details['기관배정주식수']) : 0
        var positionQuantity = ipo.portfolios.reduce((sum, port) => sum + port.position_quantity, 0)
        var positionCloseValue = ipo.portfolios.reduce((sum, port) => sum + port.position_close_value, 0)
        var recovery = ipo.allocated_quantity === 0 ? '' : `${((ipo.allocated_quantity - positionQuantity) / ipo.allocated_quantity * 100).toFixed(1)} %`
        var disparateRatio = allocatedPrice === 0 ? '' : `${((ipo.close_price / allocatedPrice - 1) * 100).toFixed(1)} %`
        var allocatedRate = baseAllocatedQuantity === 0 ? '' : `${(ipo.allocated_quantity / baseAllocatedQuantity * 100).toFixed(3)} %`

        let sum = 0
        let count = 0
        ipo.portfolios.forEach(row => {
          if (row.average_selling_price > 0) {
            sum += row.average_selling_price
            count += 1
          }
        })

        var averageSellingPrice = count === 0 ? '' : parseFloat(sum / count).toFixed(0)
        var recoveryGainLoss = ipo.allocated_quantity === 0 ? '' :
                                Number(averageSellingPrice) === 0 ? '' : (averageSellingPrice - allocatedPrice) * (ipo.allocated_quantity - positionQuantity)
        var earningsRatio = (Number(recoveryGainLoss) === 0 || ipo.allocated_quantity === 0) ? '' : `${(recoveryGainLoss / ipo.allocated_amount * 100).toFixed(1)} %`

        let rawData = [
          ipo.name,
          ipo.details['기관경쟁률'],
          ipo.details['의무보유확약'],
          this.competitionRate(ipo.details['청약경쟁률']),
          ipo.listing_date,
          this.numberStyle(ipo.details['확정공모가']),
          this.numberStyle(ipo.close_price),
          disparateRatio,
          this.numberStyle(ipo.allocated_quantity),
          this.numberStyle(ipo.allocated_amount),
          allocatedRate,
          this.numberStyle(positionQuantity),
          this.numberStyle(positionCloseValue),
          this.numberStyle(averageSellingPrice),
          this.numberStyle(recoveryGainLoss),
          recovery,
          earningsRatio,
          ipo.lockup_expiration_date,
          '',
        ]
        result += `${rawData.join('\t')}\n`

        ipo.portfolios.forEach(portfolio => {
          var publicOfferingShares

          if (portfolio.account_type === '집합') {
            publicOfferingShares = ipo.details['기관배정주식수'] ? parseFloat(ipo.details['기관배정주식수']) : 0
          } else if (portfolio.account_type === '벤처') {
            publicOfferingShares = ipo.details['총공모주식수'] ? parseFloat(ipo.details['총공모주식수']) * this.ventureRatio : 0
          } else if (portfolio.account_type === '하이일드') {
            publicOfferingShares = ipo.details['총공모주식수'] ? parseFloat(ipo.details['총공모주식수']) * this.highYieldRatio : 0
          } else if (portfolio.account_type === '고유') {
            publicOfferingShares = ipo.details['기관배정주식수'] ? ipo.details['기관배정주식수'] : 0
          } else {
            publicOfferingShares = 0
          }

          var portfolioAverageSellingPrice = portfolio.average_selling_price ? portfolio.average_selling_price.toFixed(0) : ''
          var portfolioAllocatedRate = (portfolio.allocated_quantity === 0 || publicOfferingShares === 0) ? '' : `${(portfolio.allocated_quantity / publicOfferingShares * 100).toFixed(3)} %`
          var portfolioRecoveryGainLoss = portfolio.allocated_quantity === 0 ? '' :
                                            Number(portfolioAverageSellingPrice) === 0 ? '' : ((portfolioAverageSellingPrice - allocatedPrice) * (portfolio.allocated_quantity - portfolio.position_quantity)).toFixed(0)
          var portfolioRecovery = (portfolio.position_quantity === 0 || portfolio.allocated_quantity === 0) ? '' : `${((portfolio.allocated_quantity - portfolio.position_quantity) / portfolio.allocated_quantity * 100).toFixed(1)} %`
          var portfolioEarningsRatio = (Number(portfolioRecoveryGainLoss) === 0 || portfolio.allocated_quantity === 0) ? '' : `${(portfolioRecoveryGainLoss / portfolio.allocated_amount * 100).toFixed(1)} %`

          let rawData = [
            portfolio.account_type,
            '',
            '',
            '',
            '',
            '',
            '',
            '',
            this.numberStyle(portfolio.allocated_quantity),
            this.numberStyle(portfolio.allocated_amount),
            portfolioAllocatedRate,
            this.numberStyle(portfolio.position_quantity),
            this.numberStyle(portfolio.position_close_value),
            this.numberStyle(portfolioAverageSellingPrice),
            this.numberStyle(portfolioRecoveryGainLoss),
            portfolioRecovery,
            portfolioEarningsRatio,
            portfolio.lockup_expiration_date,
            portfolio.note,
          ]
          result += `${rawData.join('\t')}\n`
        })
      })
      this.$copyText(result).then(() => {
        this.$message({
          type: 'success',
          message: '클립보드에 복사 됨.',
        })
      })
    },
    competitionRate (ipo) {
      if (ipo) {
        return (ipo).includes('비례') ? ipo.split('(비례')[0] : ipo
      } else {
        return ''
      }
    },
  },
  mounted () {
    this.refreshData()
  },
}
</script>

<style lang='scss' scoped>
  .ipo-portfolio-table-container {
    height: calc(100vh - 64px);
  }
</style>
